<template>
  <div>
    <MenuButton button-label="Settings" size="medium">
      <MenuButtonItem title="Delete building" icon="trash" variant="dangerous" @click="deleteModalRef?.open()" />
    </MenuButton>

    <BuildingDeleteModal ref="deleteModalRef" :building="building" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { MenuButton, MenuButtonItem } from '@tallo/design-system';
import { BuildingDto } from '@tallo/investor/property';

import BuildingDeleteModal from './building-delete-modal.vue';

defineProps<{ building: BuildingDto }>();

const deleteModalRef = ref<InstanceType<typeof BuildingDeleteModal>>();
</script>
